var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"stage"},[_c('timeline-slider',{attrs:{"value":_vm.value,"min":_vm.min,"max":_vm.max,"labeledValue":10,"subdivisions":2},on:{"input":_vm.input}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }